module.exports = __webpack_public_path__ + "static/img/14000672.19b3efaa.png";